import React from 'react';
import * as dates from 'date-arithmetic';
import { Navigate } from 'react-big-calendar';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';
import { withTranslation } from 'react-i18next';
import hoistStatics from 'hoist-non-react-statics';
import moment from 'moment';

class CalendarDayView extends React.Component {
	render() {
		let { date } = this.props;
		let range = CalendarDayView.range(date);
		return <TimeGrid {...this.props} range={range} eventOffset={10} />;
	}
}

CalendarDayView.range = (date) => {
	return [dates.startOf(date, 'day')];
};

CalendarDayView.navigate = (date, action, view) => {
	let { events } = view;

	const sortedLessons = events.sort(function (a, b) {
		return a.start - b.start;
	});

	const minDate = sortedLessons.length > 0 ? sortedLessons[0].start : undefined;
	const maxDate = sortedLessons.length > 0 ? sortedLessons[sortedLessons.length - 1].start : undefined;

	let days = sortedLessons.map(lesson => moment(lesson.start).format('L'));

	switch (action) {
		case Navigate.PREVIOUS:
			let prevDay = dates.add(date, -1, 'day');
			if (minDate) {
				while (dates.gte(prevDay, minDate, 'day') && days.indexOf(moment(prevDay).format('L')) < 0) {
					prevDay = dates.add(prevDay, -1, 'day');
				}
			}
			return prevDay;

		case Navigate.NEXT:
			let nextDay = dates.add(date, 1, 'day');
			if (maxDate) {
				while (dates.lte(nextDay, maxDate, 'day') && days.indexOf(moment(nextDay).format('L')) < 0) {
					nextDay = dates.add(nextDay, 1, 'day');
				}
			}
			return nextDay;
		default:
			return date;
	}
};

CalendarDayView.title = () => {
	return '';
};

// react-i18next v8's withNamespaces hoisted non-React statics onto the wrapper; v15's
// withTranslation does not. react-big-calendar reads range/navigate/title off whatever
// component it is handed, so they must be copied across or Calendar throws
// "View.title is not a function".
export default hoistStatics(withTranslation()(CalendarDayView), CalendarDayView);